module.exports = __webpack_public_path__ + "static/resume-0198f8650d4f7303ae52fb16778ad97c.pdf";